
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { Meta, Title } from '@angular/platform-browser'
import { NnDateTime } from '../nn-date-time'
import { Router, RouterModule } from '@angular/router'
import { SITE_TITLE } from '../../../shared/constants'

@Component({
  selector: 'app-date-calculator',
  imports: [
    FormsModule,
    RouterModule
],
  templateUrl: './date-calculator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './date-calculator.component.scss'
})
export class DateCalculatorComponent {

  constructor(
    private meta: Meta,
    private title: Title,
    public http: HttpClient,
    private router: Router,
  ) {

  }

  startDate!: string
  endDate!: string

  result: string = ''

  difference = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }

  differenceHumanReadable = {
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }

  ngOnInit() {
    this.title.setTitle(SITE_TITLE + " | Date Difference Calculation Tool")
    this.meta.updateTag({ name: 'description', content: 'Date and Time Tool to calculate the difference between two dates and times.' })
    this.meta.updateTag({ name: 'keywords', content: 'date, difference, calculate, tool, calculation, free, date difference, date calculator' })

    this.calculateDifference()
  }

  setEndDateToToday() {
    this.endDate = new Date().toISOString()
    this.calculateDifference()
  }

  calculateDifference() {
    if (this.endDate == null || this.endDate.trim() == '') {
      this.endDate = new Date().toISOString()
    }

    const start = new Date(this.startDate)
    const end = new Date(this.endDate)

    if (start && end) {
      const nnStart = new NnDateTime(start)
      const { days, hours, minutes, seconds } = nnStart.difference(end)
      this.difference = { days, hours, minutes, seconds }

      const { years, months, days: remainingDays } = nnStart.humanReadableDifference(end)
      this.differenceHumanReadable = { years, months, days: remainingDays, hours, minutes, seconds }
    } else {
      this.result = 'Please enter valid dates and times.'
    }
  }

  resetForm() {
    this.startDate = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString()
    this.endDate = new Date(new Date()).toISOString()
  }
}
